import { Router } from '@angular/router';
import { LoginContext } from '../../models/auth/login.context';

export abstract class LoginHandler {
  protected nextHandler: LoginHandler | null = null;

  setNext(handler: LoginHandler): LoginHandler {
    this.nextHandler = handler;
    return handler;
  }

  abstract handle(response: any, context: LoginContext): Promise<void>;
}

export class FirstLoginHandler extends LoginHandler {
  async handle(response: any, context: LoginContext): Promise<void> {
    if (response.status === 1) {
      if (context.component) {
        context.component.showFirstLogin = true;
        context.component.tempEmail = context.email;
        context.component.tempPassword = context.password;

        context.component.show2FA = false;
        context.component.showLoginWithMail = false;
        context.component.showLoginWithGoogle = false;
      }
      return;
    }

    if (this.nextHandler) {
      await this.nextHandler.handle(response, context);
    }
  }
}
export class TwoFactorHandler extends LoginHandler {
  async handle(response: any, context: LoginContext): Promise<void> {
    const authType = response.authenticatorType;

    if (authType === 1 || authType === 2 || authType === 3) {
      if (context.component) {
        context.component.showFirstLogin = false;

        if (authType === 1) {
          context.component.showGoogleSection = true;
          context.component.show2FA = false;
          context.component.showMailSection = false;
        } else {
          context.component.show2FA = true;
          context.component.showGoogleSection = false;

          if (authType === 2) {
            context.component.showMailSection = true;
          }
        }
      }
      return;
    }
    if (this.nextHandler) {
      await this.nextHandler.handle(response, context);
    }
  }
}

export class NavigationHandler extends LoginHandler {
  constructor(private router: Router) {
    super();
  }

  async handle(response: any, context: LoginContext): Promise<void> {
    await this.router.navigateByUrl('/dashboard');
  }
}
